import React, { Component, createRef } from "react"
import {
  Container, Row, Col, Card, CardBody, Label, FormGroup, Input, InputGroup,
  DropdownItem, DropdownMenu, DropdownToggle, Table, UncontrolledDropdown, Offcanvas, OffcanvasHeader, OffcanvasBody, Nav, NavItem, NavLink, TabPane, TabContent, CardTitle,
  CardHeader
} from "reactstrap"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr"
import { Link } from "react-router-dom"
import { map } from "lodash"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from "axios"
import Moment from 'react-moment';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addContactActivityFollowUp, addTabCall, addTabEmail, addTabNote, getContactActivityFollowUp, getContacts, getTabCall, getTabEmail, getTabNote } from "../../store/actions"
import FilterMenuContact from "./filter-menu/filter-menu"
import RsAdNew from "components/buttons/Adnew";
import CreateContact from "./forms/contact-create"
import ContactEdit from './forms/contact-edit';
import Contacts from ".";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import notes from "../../assets/images/rsicons/notes.png";
import follow from "../../assets/images/rsicons/follow-up.png";
import phonelog from "../../assets/images/rsicons/phone-log.png";
import emaillog from "../../assets/images/rsicons/email-log.png";
import classnames from "classnames"
import moment from "moment-timezone";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
  addLeadNoteTab, getLeads, getNoteLeadTab, getListLeadTab, addFollowNoteTab, getFollowLeadTab,
  getLeadCallLog, addLeadCallLog, addLeadEmailLog, getLeadEmailLog, getAllContactActivityTab, deleteLead
} from "../../store/actions"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import RsCard from "components/Rscards/Rscard";
import { API_URL } from "helpers/app_url";
import RSPieChart from "components/charts/RSPieChart";
import AiButton from "components/buttons/aiBtn";
import ActionRefferal from "components/buttons/actionRefferal";
import SaveButton from "components/buttons/save";
import allContactIcon from "../../assets/img/all-contact-icon.png"
import vipContactIcon from "../../assets/img/vip-contact-icon.png"
import refferalIcon from "../../assets/img/refferal-icon.png"
import RsCardImg from "components/Rscards/Rscard-img";
import ActionDeleteFade from "components/buttons/actionDeleteFade";
import ActionEditLink from "components/buttons/actionEditlink";
import ActionActivity from "components/buttons/actionActivity";
import RsAdNewV2 from "components/buttons/Adnew-v2";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import CopyText from "components/buttons/copyBtn";
import TimePicker from "components/dropdowns/Timepicker";
import clientCircle from "../../assets/img/client-circle-icon.png"
import RsLink from "components/buttons/rsLink";
import { MultiSelect } from 'primereact/multiselect';
import messageIcon from "../../assets/img/message-icon-new.png"
import RichTextEditor from "components/dropdowns/ContentEditor";
import SafeField from "helpers/SafeField";
class AllContacts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contacts: [],
      contactData: {},
      searchTerm: '',
      activeTab3: "2",
      activeRef: "1",
      lead: '',
      expandedRows: null, 
      upcomingActivities: [],
      reports: [
        { title: "# Contacts", iconClass: allContactIcon, description: "loading...." },
        { title: "VIP Contacts", iconClass: vipContactIcon, description: "loading...." },
        { title: "Referrals generated this year", iconClass: refferalIcon, description: "loading...." },
        // { title: "Lead to client conversion", iconClass: "bx bx-plus-medical", description: "22%" },
      ],
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.onSearchChang = this.onSearchChang.bind(this);
    this.isAllCanavas = this.isAllCanavas.bind(this);
    this.referralCanavas = this.referralCanavas.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this)
    this.dt = createRef();
  }
  handleSubmit = (value, { resetForm }) => {
    const payload = {
      messageFromId: parseInt(value.messageFromId),
      messageToId: parseInt(value.messageToId),
      messageFrom: value.messageFrom,
      messageTo: value.messageTo,
      messageText: value.messageText,
      agentId: parseInt(value.agentId),
      isActive: true,
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}ContactMessage`;
    toast.loading("Please wait...");
    axios
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Saved successfully!");
          resetForm();
          this.fetchLeadMessage(value.messageToId);
        } else {
          toast.dismiss();
          toast.error('some issue while sending message');
          console.warn("Submission failed:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error sending message:", error);

      });
  }
  fetchLeadMessage(leadId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      ContactId: leadId,
      agentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ContactMessage/allContact`, { headers, params })
      .then((response) => {
        this.setState({ leadMessages: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  toggleReferral() {
    this.setState({ isReferral: !this.state.isReferral });
  }

  referralCanavas = arg => {
    const contactRef = arg;
    this.setState({
      contactRef: {
        id: contactRef.id,
        email: contactRef.email,
        mobile: contactRef.mobile,
        isClient: contactRef.isClient
      },
    });
    this.fetchReferralRequestEmail(contactRef.id);
    this.fetchReviewsRequestEmail(contactRef.id);
    this.fetchSurveyRequestEmail(contactRef.id);
    this.fetchAllReferral(contactRef.id);
    this.fetchReferralHistory(contactRef.id)
    this.fetchSurveyHistory(contactRef.id)
    this.toggleReferral();
  }
  referralCanavas() {
    this.setState(prevState => ({
      isReferral: !prevState.isReferral,
      activeRef: !prevState.isReferral ? "1" : prevState.activeRef
    }));
  }
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleReff(tab) {
    if (this.state.activeRef !== tab) {
      this.setState({
        activeRef: tab,
      });
    }
  }
  toggleRightCanvas = arg => {
    const data = arg;
    //const { onGetFollowLead } = this.props;
    this.setState({
      contactData: data
    });
    this.setState({ isRight: !this.state.isRight });
  };

  toggleRightCanvas() {

  }

  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });

  }
  fetchReferralRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ContactId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentreferraltemplate`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const emailContent = res.data || '';
      this.setState({ emailContent: emailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };
  fetchAllReferral = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      contactId: ContactId
    };

    axios.get(`${API_URL}Lead/allforcontact`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allreferrals = res.data || '';
      this.setState({ allreferrals: allreferrals, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };
  fetchReviewsRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ContactId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentreviewtemplate`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const reviewemailContent = res.data || '';
      this.setState({ reviewemailContent: reviewemailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchSurveyRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ContactId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentsurveytemplate`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const surveyemailContent = res.data || '';
      this.setState({ surveyemailContent: surveyemailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };
  fetchReferralHistory = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      contactId: ContactId
    };

    axios.get(`${API_URL}ContactConnect/allforcontact`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allHistory = res.data || '';
      this.setState({ allHistory: allHistory, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchSurveyHistory = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      contactId: ContactId
    };

    axios.get(`${API_URL}ContactSurvey/allforcontact`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allSurveys = res.data || '';
      this.setState({ allSurveys: allSurveys, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };
  componentDidMount() {
    const { onGetAllContact } = this.props;
    onGetAllContact(localStorage.getItem('userId'));
    this.fetchLeadSourceData();
    this.fetchContactCountDashboardByAgent();
    this.fetchUpcomingContact({ agentId: localStorage.getItem('userId') })
    this.fetchUpcomingConnected({ agentId: localStorage.getItem('userId') })
    //this.fetchReferralRequestEmail();
  }
  fetchContactCountDashboardByAgent = async () => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const str = `Bearer ${token}`;

    try {
      const response = await axios.get(`${API_URL}Contact/getContactCountDashboardByAgentQuery`, {
        params: {
          agentId: localStorage.getItem("userId"),

        },
        headers: { Authorization: str }
      });

      if (response.data && Array.isArray(response.data)) {
        const totalContacts = response.data.find(item => item.sources === "Total")?.counts || 0;
        const vipContacts = response.data.find(item => item.sources === "VIP")?.counts || 0;
        const goldContacts = response.data.find(item => item.sources === "Gold")?.counts || 0;
        const silverContacts = response.data.find(item => item.sources === "Silver")?.counts || 0;
        const notsetContacts = response.data.find(item => item.sources === "Not Set")?.counts || 0;
        const reffContacts = response.data.find(item => item.sources === "LastYearReferral")?.counts || 0;

        this.setState(prevState => ({
          reports: prevState.reports.map(report => {
            if (report.title === "# Contacts") return { ...report, description: totalContacts };
            if (report.title === "VIP Contacts") return { ...report, description: vipContacts };
            if (report.title === "Referrals generated this year") return { ...report, description: reffContacts };
            return report;
          })
        }));

         this.setState({
            totalContacts : totalContacts || 0,
            vipContacts : vipContacts || 0,
            goldContacts : goldContacts || 0,
            silverContacts : silverContacts || 0,
            notsetContacts: notsetContacts || 0,
            reffContacts : reffContacts || 0
        });
      }
    } catch (error) {
      console.error("Error fetching lead counts:", error);
    }
  };
  fetchLeadSourceData = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Contact/getContactClassificationDashboardByAgentQuery?agentId=${agentId}`;
    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data && Array.isArray(response.data)) {
        const sources = response.data.map(item => item.sources);
        const counts = response.data.map(item => parseInt(item.counts));
        this.setState({
          leadSourceData: {
            series: counts,
            options: {
              chart: { type: "pie" },
              labels: sources,
              colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };
  onSearchChang(event) {
    this.setState({ searchTerm: event.target.value });
  }

  toggleAllCanavas() {
    this.setState(prevState => ({
      isAll: !prevState.isAll,
      activeTab3: !prevState.isAll ? "2" : prevState.activeTab3
    }));
  }
  isAllCanavas() {
    this.setState({ lead: "", isAll: !this.state.isAll });
    this.toggleAllCanavas();
  }
  isAllCanavas = arg => {
    const lead = arg;
    const { onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog, onGetAllActLead } = this.props;
    this.setState({
      lead: {
        leadId: lead.id,
        contactName: lead.firstName + " " + lead.lastName,
        email: lead.email,
        mobile: lead.mobile
      },
    });

    onGetAllActLead(lead.id)
    this.toggleAllCanavas();
  }
  handleStartTime = (setFieldValue, values) => {
    const { startHrs, startMin, startDif } = values;
    const hours = parseInt(startHrs, 10);
    const minutes = parseInt(startMin, 10);
    const meridiem = startDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('startTime', formattedTime);

  };
  handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        setFieldValue('activityLocation', place.formatted_address);
        setFieldValue('activityLatitude', longitude);
        setFieldValue('activityLongitude', latitude);
      })
      .catch(error => console.error('Error', error));
  };
  handleEndTime = (setFieldValue, values) => {
    const { endHrs, endMin, endDif } = values;
    const hours = parseInt(endHrs, 10);
    const minutes = parseInt(endMin, 10);
    const meridiem = endDif === 'PM' && hours < 12 ? hours + 12 : hours;
    const date = new Date();
    const formattedTime = moment()
      .set({ hour: meridiem, minute: minutes })
      .format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    setFieldValue('endTime', formattedTime);

  };
  handleInsertAi = (generatedText, setFieldValue) => {
    setFieldValue("addMessage", generatedText);
  };


  handleSubmitReferalRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 1,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Saved successfully!");
        this.setState({ isReferral: false });
        //this.referralCanavas();
      } else {
        toast.dismiss();
        toast.error("Failed to submit referral request.");
      }
    } catch (error) {
      console.error("Error submitting referral request:", error);

    } finally {
      setSubmitting(false);
    }
  };

  handleSubmitReviewRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 2,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Saved successfully!");
        this.setState({ isReferral: false });
      } else {
        toast.dismiss();
        toast.error("Failed to submit review request.");
      }
    } catch (error) {
      console.error("Error submitting review request:", error);

    } finally {
      setSubmitting(false);
    }
  };

  handleSubmitSurveyRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 3,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Saved successfully!");
        this.setState({ isReferral: false });
      } else {
        toast.dismiss();
        toast.error("Failed to submit survey request.");
      }
    } catch (error) {
      console.error("Error submitting survey request:", error);

    } finally {
      setSubmitting(false);
    }
  };


  fetchUpcomingContact(params = {}) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    axios.get(`${API_URL}Lead/allforagentreferralwithcontact`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    })
      .then(secondResponse => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();
        const filteredContacts = (secondResponse.data || []).filter(contact => {
          const submittedDate = new Date(contact.submittedDate);
          return (
            submittedDate.getMonth() === currentMonth &&
            submittedDate.getFullYear() === currentYear
          );
        });

        this.setState({
          upcomingContacts: filteredContacts,
          isLoading: false,
        });
      })
      .catch(error => {
        console.error('Error fetching data from second API:', error);
        this.setState({ isLoading: false });
      });
  }
  fetchUpcomingConnected(params = {}) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    axios.get(`${API_URL}Contact/allforagentnextconnectdate`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    })
      .then(secondResponse => {
        this.setState({
          upcomingConnectes: secondResponse.data || [],
          isLoading: false,
        });
      })
      .catch(error => {
        console.error('Error fetching data from second API:', error);
        this.setState({ isLoading: false });
      });
  }
  formatClassification = (id) => {
  switch (id) {
    case 1: return "Silver";
    case 2: return "Gold";
    case 3: return "VIP";
    case 4: return "Investor";
    case 5: return "Vendors";
    default: return "Un Assigned";
  }
}
  render() {
    const { onAddLeadNote, onAddLeadFollowUp, onAddCallLog, onAddEmailLog, userdetail, isResponsive } = this.props;
    const { leadNotes, leadFollows, calllogs, emaillogs, allactivities } = this.props;
    const { upcomingContacts, leadMessages } = this.state;

    const { searchTerm, lead, contactRef } = this.state;
    const { contacts, gridLoading } = this.props;
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { onGetAllActLead, onGetFollowLead, onGetNoteLead, onGetLeadCallLog, onGetLeadEmailLog } = this.props;

    const lastContactSorter = (e) => {
      const parseDate = (dateStr) => {
        if (!dateStr) return new Date(0);
        const [day, month, year] = dateStr.split(' ');
        const fullYear = parseInt(year, 10) > 50 ? `19${year}` : `20${year}`;
        return new Date(`${day} ${month} ${fullYear}`);
      };
      const value1 = parseDate(e.value1);
      const value2 = parseDate(e.value2);
      return value2 - value1;
    };

    const filteredData = contacts.filter(data => {
      const nameMatch = data.firstName && data.firstName.trim() !== ''
        ? data.firstName.toLowerCase().includes(searchTerm.toLowerCase())
        : false; // Exclude if null, undefined, or blank    
      return nameMatch; // Use && if all terms are required
    });
  
const classificationOptions = [
  { label: "Gold", value: 2 },
  { label: "Silver", value: 1 },
  { label: "VIP", value: 3 },
  { label: "Investor", value: 4 },
  { label: "Vendors", value: 5 },
  { label: "Un Assigned", value: 0 } // optional
];
const frequencyOptions = [
  { label: "Monthly", value: "Monthly" },
  { label: "Quarterly", value: "Quarterly" },
  { label: "Semi-annual", value: "Semi-annual" },
  { label: "Annual", value: "Annual" }
];

    return (
      <React.Fragment>
        {gridLoading ? (
          <div className="rs-loader-overlay">
            <div className="rs-loader"></div>
          </div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            <Row className="project-header">
              <Col xl="7" >
                <Breadcrumbs
                  title={this.props.t("Contact")}
                  breadcrumbItem={this.props.t("All Contacts")}
                />
              </Col>
              <Col xl="5">
                <div className="pt-2 float-end mt-2">
                  <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="border-right" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>
                  {!isResponsive &&(
                      <RsAdNewV2 to="/contact/import-contact" className="" iconClass=" bx bx-upload font-size-18">Import contacts</RsAdNewV2>
                  )}
                  

                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">
           
                <div className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                  <RsCardImgv4 description={this.state.totalContacts} title="# Contacts" iconClass={allContactIcon} />
                </div>
                 <div className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                  <Card className="card rs-card-v4 bg-v2 rs-card-compact">
                    <CardBody className="d-flex align-items-center text-center" style={{padding:'0.65rem 1.25rem'}}>
                         <img 
                            src={vipContactIcon} 
                            alt="leads" 
                            style={{ width: 36 }} 
                            className="me-3 d-none d-md-block" 
                          />

                           <div>
                            
                            <div className="d-flex flex-wrap justify-content-center gap-3 rs-status-text">
                              <span><strong>VIP : </strong>{this.state.vipContacts}</span>
                              <span><strong>Gold : </strong>{this.state.goldContacts}</span>
                              <span><strong>Silver : </strong>{this.state.silverContacts}</span>
                              <span><strong>Not Set : </strong>{this.state.notsetContacts}</span>
                            </div>
                          </div>
                    </CardBody>
                  </Card>
                 
                </div>
                <div className="flex-grow-1 flex-shrink-0" style={{ flexBasis: "calc(20% - 1rem)" }}>
                  <RsCardImgv4 description={this.state.reffContacts} title="Referrals generated this year" iconClass={refferalIcon} />
                </div>
           
            </div>


            <Row>
              <Col lg="12">

                <Row>
                  <Col sm="4" className="d-flex">
                    <div className="card border-full mt-4 w-100">
                      <div className="card-body d-flex flex-column">
                        {this.state.leadSourceData && <RSPieChart title="Contacts by classification" filter={false} {...this.state.leadSourceData} />}
                      </div>
                    </div>
                  </Col>
                  <Col lg="4" className="d-flex">
                    <div className="card border-full mt-4 w-100">
                      <div className="card-body d-flex flex-column">
                        <div className="card-title mb-4 float-start">Referrals generated this month</div>
                        <div className="clearfix"></div>
                        <div className="table-responsive flex-grow-1 overflow-auto table-wrapper" style={{ height: 370 }}>
                          <table className="table table-fixed-header mb-0">
          <thead>
            {window.innerWidth < 768 ? (
             
              <tr>
                <th>Date</th>
                <th>Name</th>
              </tr>
            ) : (
             
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Referred from</th>
                <th>Last contact</th>
              </tr>
            )}
          </thead>

          <tbody>
            {upcomingContacts && upcomingContacts.length > 0 ? (
              upcomingContacts.map((activity, index) => {
    
                const openRow = this.state.openRow;
                const toggleRow = (id) => this.setState({ openRow: openRow === id ? null : id });

                return isResponsive ? (
           
                  <React.Fragment key={index}>
                    <tr
                      onClick={() => toggleRow(index)}
                      style={{ cursor: "pointer", background: openRow === index ? "#f8f9fa" : "transparent" }}
                    >
                      <td><Moment format="DD MMM">{activity.submittedDate}</Moment></td>
                      <td>
                        {activity.firstName + " " + activity.lastName}
                        <i className={`bx ${openRow === index ? "bx-chevron-up" : "bx-chevron-down"} float-end`}></i>
                      </td>
                    </tr>

                    {openRow === index && (
                      <tr>
                        <td colSpan="2" className="bg-light">
                          <div><strong>Referred from:</strong> {activity.referedByContact?.firstName + " " + activity.referedByContact?.lastName}</div>
                          <div><strong>Last contact:</strong> {activity.lastContact ? <Moment format="DD MMM YY">{activity.lastContact}</Moment> : 'N/A'}</div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ) : (
                
                  <tr key={index}>
                    <td><Moment format="DD MMM">{activity.submittedDate}</Moment></td>
                    <td>{activity.firstName + " " + activity.lastName}</td>
                    <td>{activity.referedByContact?.firstName + " " + activity.referedByContact?.lastName}</td>
                    <td>{activity.lastContact ? <Moment format="DD MMM YY">{activity.lastContact}</Moment> : 'N/A'}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={window.innerWidth < 768 ? 2 : 4} style={{ textAlign: "center" }}>No activities found</td>
              </tr>
            )}
          </tbody>
        </table>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg="4" className="d-flex">
                   <div className="card border-full mt-4 w-100">
  <div className="card-body d-flex flex-column">
    <div className="card-title mb-4 float-start">
      Upcoming contact that shud be connected with this month
    </div>

    <div className="table-responsive flex-grow-1 overflow-auto table-wrapper" style={{ height: 370 }}>
      <table className="table table-fixed-header mb-0">
        <thead>
          {window.innerWidth < 768 ? (
           
            <tr>
              <th>Name</th>
              <th>Phone</th>
            </tr>
          ) : (
            // ✅ DESKTOP HEADER: Full Columns
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Frequency</th>
              <th>Last Connect</th>
              <th>Detail</th>
            </tr>
          )}
        </thead>

        <tbody>
          {this.state.upcomingConnectes && this.state.upcomingConnectes.length > 0 ? (
            this.state.upcomingConnectes.map((connect, index) => {
             
              const openRow = this.state.openUpcomingRow;
              const toggleRow = (id) =>
                this.setState({ openUpcomingRow: openRow === id ? null : id });

              return isResponsive ? (
               
                <React.Fragment key={index}>
                  <tr onClick={() => toggleRow(index)} style={{ cursor: "pointer" }}>
                    <td>{connect.firstName + " " + connect.lastName}</td>
                    <td>
                      {connect.mobile}
                      <i
                        className={`bx ${
                          openRow === index ? "bx-chevron-up" : "bx-chevron-down"
                        } float-end`}
                      ></i>
                    </td>
                  </tr>

                  {openRow === index && (
                    <tr>
                      <td colSpan="2" className="bg-light">
                        <div><strong>Frequency:</strong> {connect.connectFrequency}</div>
                        <div>
                          <strong>Last Connect:</strong>{" "}
                          {connect.lastContact ? (
                            <Moment format="DD MMM YY">{connect.lastContact}</Moment>
                          ) : (
                            "N/A"
                          )}
                        </div>
                        <div>
                          <strong>Detail:</strong>{" "}
                          <ActionEditLink to={`/contact/contact-detail/${connect.id}/${connect.contactId}`} />
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ) : (
               
                <tr key={index}>
                  <td>{connect.firstName + " " + connect.lastName}</td>
                  <td>{connect.mobile}</td>
                  <td>{connect.connectFrequency}</td>
                  <td>
                    {connect.lastContact ? (
                      <Moment format="DD MMM YY">{connect.lastContact}</Moment>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <th>
                    <ActionEditLink to={`/contact/contact-detail/${connect.id}/${connect.contactId}`} />
                  </th>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={window.innerWidth < 768 ? 2 : 5} style={{ textAlign: "center" }}>
                No activities found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>

                  </Col>
                </Row>

              </Col>
            </Row>



            <Row>
              <Col lg="12">

                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-5 pe-0" style={{width: 660}}>
                        <FilterMenuContact />

                        
                      </div>
                      {!isResponsive && (
                        <>
                             <div className="col-sm-3 ps-0">
                         <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2`}
                  >
                     <span className="d-flex align-items-center gap-2">
                    <img src={clientCircle} style={{height:16}} />
                    
                  Contact is a client (cannot delete)
                     </span>
                  </button>
                        </div>
                        </>
                      )}
                 
                   <div className="col-sm-4">
                        <div className="input-group position-relative">
                          <Input type="text" value={searchTerm} onChange={this.onSearchChang} id="autoSizingInputProject" placeholder="Search By Name" />
                          {searchTerm && (
                            <button
                              className="btn btn-clear position-absolute"
                              style={{
                                right: "40px",
                                top: "48%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => this.setState({ searchTerm: "" })}
                            >
                              ✖
                            </button>
                          )}

                          <span className="input-group-text search-btn" id="basic-addon1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </div>
                      </div> 
                    </div>
                  </CardHeader>
                  <CardBody>


                    <div className="table-responsive">
                      {isResponsive ? (
                        <>
                        <DataTable
  value={filteredData}
  dataKey="id"
  responsiveLayout="stack"
  expandedRows={this.state.expandedRows}
  onRowToggle={(e) => this.setState({ expandedRows: e.data })}
  paginator
  rows={10}
  rowExpansionTemplate={(rowData) => (
    <table className="table table-bordered mb-0">
      <tbody>
        <tr>
          <th style={{ width: '40%' }}>Email</th>
          <td>{rowData.email || 'N/A'}</td>
        </tr>
        <tr>
          <th>Last Contact</th>
          <td>
            {rowData.lastContact ? (
              <Moment format="D MMM YY">{rowData.lastContact}</Moment>
            ) : (
              'N/A'
            )}
          </td>
        </tr>
        <tr>
          <th>Classification</th>
          <td>
            {rowData.contactClassificationId
              ? this.formatClassification(rowData.contactClassificationId)
              : 'N/A'}
          </td>
        </tr>
        <tr>
          <th>Status</th>
          <td>
            {rowData.leadStatusId > 1
              ? localization['LeadStatus_' + rowData.leadStatusId]
              : 'N/A'}
          </td>
        </tr>
      </tbody>
    </table>
  )}
>
  {/* Expander */}
  <Column expander style={{ width: '3em' }} />
   <Column
    header="#"
    body={(rowData, options) => options.rowIndex + 1}
    style={{ width: '60px' }}
  />
  {/* Name */}
  <Column
    field="fullName"
    header="Name"
    body={(rowData) => (
      <Link to={`/contact/contact-detail/${rowData.id}/${rowData.contactId}`}>
        {rowData.firstName} {rowData.lastName}
      </Link>
    )}
  />

  {/* Mobile */}
  <Column field="mobile" header="Mobile" />
</DataTable>

                        </>
                      ):(
                        <>
                         <DataTable className="" ref={this.dt} filterDisplay="menu" stripedRows value={filteredData} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}  >
                           <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        />
                        <Column headerClassName="align-middle" bodyClassName="table-data" field="firstName" header="Name"
                         filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false}         
                        body={(rowData) => (<div className="row">
                          <div className="col-sm-8" >
                            
                            <Link to={"/contact/contact-detail/" + rowData.id + "/" + rowData.contactId}>{rowData.firstName} {rowData.lastName}</Link></div>
                         
                        </div>)}>
                        </Column>
                      
                        <Column headerClassName="align-middle" bodyClassName="table-data" field="mobile" header="Mobile" body={(rowData) => (rowData.mobile)}
                        filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false} 
                        ></Column>
                         <Column headerClassName="align-middle" bodyClassName="table-data" field="email" header="Email" 
                         filter
                            showFilterMatchModes={false}  
                            showFilterOperator={false}     
                            showAddButton={false}       
                            showClearButton={false} 
                         body={(rowData) => (rowData.email)}></Column> 
                        <Column headerClassName="align-middle" bodyClassName="table-data" field="firstName"  header="Last Connect" body={(rowData) => (rowData.lastContact ? <Moment format="D MMM YY">{rowData.lastContact}</Moment> : '-')}></Column>
                       
                       <Column
                            header="Classification"
                            field="contactClassificationId"
                            headerClassName="align-middle"
                            bodyClassName="table-data"
                            filter
                            showFilterMatchModes={false}
                            showFilterOperator={false}
                            filterMatchMode="in"
                            showAddButton={false} 
                            filterElement={(options) => (
                              <MultiSelect
                                value={options.value}
                                options={classificationOptions}
                                onChange={(e) => options.filterApplyCallback(e.value)}
                                placeholder="Select Classification"
                                display="chip"
                                className="p-column-filter"
                              />
                            )}
                            body={(rowData) => {
                              switch (rowData.contactClassificationId) {
                                case 1: return "Silver";
                                case 2: return "Gold";
                                case 3: return "VIP";
                                case 4: return "Investor";
                                case 5: return "Vendors";
                                default: return "Un Assigned";
                              }
                            }}
                          />
                    <Column
                      header="Frequency"
                      field="connectFrequency"
                      headerClassName="align-middle"
                      bodyClassName="table-data"
                      filter
                      showFilterMatchModes={false}
                      showFilterOperator={false}
                      showAddButton={false} 
                      filterMatchMode="equals"  
                      filterElement={(options) => (
                        <select
                          value={options.value || ""}
                          onChange={(e) => options.filterApplyCallback(e.target.value)}
                          className="form-control"
                        >
                          <option value="">Select</option>
                          {frequencyOptions.map((f) => (
                            <option key={f.value} value={f.value}>{f.label}</option>
                          ))}
                        </select>
                      )}
                      body={(rowData) => (rowData.connectFrequency ? rowData.connectFrequency : '-')}
                    />
                                            <Column headerClassName="align-middle action-header" bodyClassName="table-data" field="firstName"
                        header={
                        <div className="justify-content-end">
                          <RsLink
                            onClick={() => this.dt.current.reset()}
                            iconClass="bx bx-reset"
                            className="btn-light"
                          >
                           Reset all filters
                          </RsLink>
                        </div>
                      }
                        body={(rowData) => (
                          <>
                            {!rowData.isClient ?
                              <ActionDelete to="#" />
                              : <ActionDeleteFade to="#" />
                            }
                           
                            <ActionEditLink to={"/contact/contact-detail/" + rowData.id + "/" + rowData.contactId} />

                            {/* <ActionActivity to="#" onClick={() => this.isAllCanavas(rowData)} /> */}

                            <ActionRefferal to="#" onClick={() => this.referralCanavas(rowData)} />
                          </>
                        )}>
                        </Column>
                        </DataTable>
                        </>
                      )}
                     


                
                      
                    </div>



                       
                  </CardBody>
                </Card>

              </Col>
            </Row>
          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isReferral}
          direction="end"
          toggle={this.referralCanavas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.referralCanavas}>
            Engagement & Support
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "1",
                  })}
                  onClick={() => {
                    this.toggleReff("1");
                  }}
                >
                  Referral Request
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "5",
                  })}
                  onClick={() => {
                    this.toggleReff("5");
                  }}
                >
                  Referrals
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "2",
                  })}
                  onClick={() => {
                    this.toggleReff("2");
                  }}
                >
                  Reviews
                </NavLink>
              </NavItem>
              {contactRef?.isClient &&(
                 <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "3",
                  })}
                  onClick={() => {
                    this.toggleReff("3");
                  }}
                >
                  Survey
                </NavLink>
              </NavItem>
              )}
             
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "4",
                  })}
                  onClick={() => {
                    this.toggleReff("4");
                  }}
                >
                  History
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent
              activeTab={this.state.activeRef}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <Formik
                  enableReinitialize={true}
                  initialValues={{

                    contactId: parseInt(contactRef?.id),
                    agentId: parseInt(localStorage.getItem("userId")),
                    contactConnectType: 1,
                    email: contactRef?.email || '',
                    mobile: contactRef?.mobile || '',
                    sentOn: new Date(),
                    subject: this.state.emailContent?.templateEmailSubject || '',
                    notes: this.state.emailContent?.templateEmailBody || '',
                    smsContent: this.state.emailContent?.templateSMSBody || '',


                  }}
                  validationSchema={Yup.object().shape({
                    subject: Yup.string().required(
                      "This is required"
                    )
                  })}

                  onSubmit={this.handleSubmitReferalRequestEmail}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>
                        <Col sm="12">
                          <div className="link-page">
                            <h5>
                              URL: <a target="_blank" rel="noreferrer" href={this.state.emailContent?.hrefLandingPage}>{this.state.emailContent?.hrefLandingPage}</a> <CopyText textToCopy={this.state.emailContent?.hrefLandingPage} />
                            </h5>
                          </div>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="subject">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="subject"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.subject && touched.subject
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="subject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>





                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Email Content")}
                            </Label>
                                    <RichTextEditor
                                    name="notes"
                                    setFieldValue={setFieldValue}
                                    initialContent={values.notes}
                                    placeholder="Enter email content here..."
                                  />
                            {/* <CKEditor
                              editor={ClassicEditor}
                              data={values.notes}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('notes', data);
                              }}
                            /> */}
                            <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="smsContent">
                              {this.props.t("SMS Content")}
                            </Label>
                            <SafeField
                              name="smsContent"
                              as="textarea"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.smsContent && touched.smsContent
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="smsContent"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                      </Row>
                    </Form>
                  )}
                </Formik>
              </TabPane>
              <TabPane tabId="2">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    //subject:'',
                    contactId: parseInt(contactRef?.id),
                    agentId: parseInt(localStorage.getItem("userId")),
                    contactConnectType: 2,
                    email: contactRef?.email || '',
                    mobile: contactRef?.mobile || '',
                    sentOn: new Date(),
                    subject: this.state.reviewemailContent?.templateEmailSubject || '',
                    notes: this.state.reviewemailContent?.templateEmailBody || '',
                    reviewsmsContent: this.state.reviewemailContent?.templateSMSBody || '',


                  }}
                  validationSchema={Yup.object().shape({
                    subject: Yup.string().required(
                      "This is required"
                    )
                  })}

                  onSubmit={this.handleSubmitReviewRequestEmail}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>


                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="subject">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="subject"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.subject && touched.subject
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="subject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>





                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Email Content")}
                            </Label>
                             <RichTextEditor
                                    name="notes"
                                    setFieldValue={setFieldValue}
                                    initialContent={values.notes}
                                    placeholder="Enter email content here..."
                                  />
                            {/* <CKEditor
                              editor={ClassicEditor}
                              data={values.notes}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('notes', data);
                              }}
                            /> */}
                            <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="reviewsmsContent">
                              {this.props.t("SMS Content")}
                            </Label>
                            <SafeField
                              name="reviewsmsContent"
                              as="textarea"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.reviewsmsContent && touched.reviewsmsContent
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="reviewsmsContent"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                      </Row>
                    </Form>
                  )}
                </Formik>
              </TabPane>
              <TabPane tabId="3">
                {this.state.allSurveys?.length > 0 ? (

                  <>
                    <table className="table">
                      <tbody>
                        <tr>
                          <th style={{ width: '30%' }}>Submitted Date</th>
                          <td><Moment format="D MMM YY">{this.state.allSurveys[0]?.addedOn}</Moment></td>
                        </tr>

                        <tr>
                          <th style={{ width: '30%' }}>Overall, how statified were you?</th>
                          <td>{this.state.allSurveys[0]?.howSatisfied}</td>
                        </tr>

                        <tr>
                          <th>What did you like most about the experience?</th>
                          <td>{this.state.allSurveys[0]?.mostLiked}</td>
                        </tr>
                        <tr>
                          <th>What could we improve?</th>
                          <td>{this.state.allSurveys[0]?.whatNeedToImprove}</td>
                        </tr>

                        <tr>
                          <th>Would you work with us again?</th>
                          <td>{this.state.allSurveys[0]?.workWithUsAgain}</td>
                        </tr>

                        <tr>
                          <th>Can we contact you about your feedback</th>
                          <td>{this.state.allSurveys[0]?.canConnectForFeedback}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        //subject:'',
                        contactId: parseInt(contactRef?.id),
                        agentId: parseInt(localStorage.getItem("userId")),
                        contactConnectType: 3,
                        email: contactRef?.email || '',
                        mobile: contactRef?.mobile || '',
                        sentOn: new Date(),
                        subject: this.state.surveyemailContent?.templateEmailSubject || '',
                        notes: this.state.surveyemailContent?.templateEmailBody || '',
                        reviewsmsContent: this.state.surveyemailContent?.templateSMSBody || '',


                      }}
                      validationSchema={Yup.object().shape({
                        subject: Yup.string().required(
                          "This is required"
                        )
                      })}

                      onSubmit={this.handleSubmitSurveyRequestEmail}
                    >
                      {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col sm="12">
                              <div className="link-page">
                                <h5>
                                  URL: <a target="_blank" rel="noreferrer" href={this.state.surveyemailContent?.hrefLandingPage}>{this.state.surveyemailContent?.hrefLandingPage}</a> <CopyText textToCopy={this.state.emailContent?.hrefLandingPage} />
                                </h5>
                              </div>
                            </Col>

                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="subject">
                                  {this.props.t("Subject")}
                                </Label>
                                <SafeField
                                  name="subject"
                                  type="text"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.subject && touched.subject
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="subject"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>





                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes">
                                  {this.props.t("Email Content")}
                                </Label>
                                 <RichTextEditor
                                    name="notes"
                                    setFieldValue={setFieldValue}
                                    initialContent={values.notes}
                                    placeholder="Enter email content here..."
                                  />
                                {/* <CKEditor
                                  editor={ClassicEditor}
                                  data={values.notes}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setFieldValue('notes', data);
                                  }}
                                /> */}
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="reviewsmsContent">
                                  {this.props.t("SMS Content")}
                                </Label>
                                <SafeField
                                  name="reviewsmsContent"
                                  as="textarea"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.reviewsmsContent && touched.reviewsmsContent
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="reviewsmsContent"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}


              </TabPane>
              <TabPane tabId="4">
                <ul className="verti-timeline list-unstyled">
                  {this.state.allHistory && this.state.allHistory.length > 0 && (
                    this.state.allHistory.map((history, index) => (
                      <li key={index} className="event-list eventlist">
                        <div className="event-timeline-dot"></div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{history.sentOn}</Moment>

                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">
                              {history.subject || 'N/A'}
                            </h5>
                          </div>
                        </div>

                      </li>
                    ))
                  )}
                </ul>
              </TabPane>
              <TabPane tabId="5">
                <ul className="verti-timeline list-unstyled">
                  {this.state.allreferrals && this.state.allreferrals.length > 0 && (
                    this.state.allreferrals.map((referral, index) => (
                      <li key={index} className="event-list eventlist">
                        <div className="event-timeline-dot"></div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{referral.submittedDate}</Moment>

                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">
                             {referral.firstName + " " + referral.lastName || 'N/A'}  {referral.isConvertedToClient &&(
                               <span className="c-border">Client</span>
                             )}
                            </h5>
                          </div>
                        </div>
                        <div className="exNote">
                          Phone : {referral.mobile || 'N/A'}
                          <br />

                          {referral.notes ? `Notes: ${referral.notes}` : ''}
                          
                        </div>
                       

                      </li>
                    ))
                  )}
                </ul>
              </TabPane>

            </TabContent>

          </OffcanvasBody>
        </Offcanvas>
        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Contact
          </OffcanvasHeader>
          <OffcanvasBody>
            <CreateContact toggleAddNew={this.toggleAddNew} />
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isRight}
          direction="end"
          toggle={this.toggleRightCanvas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleRightCanvas}>
            Update Contact
          </OffcanvasHeader>
          <OffcanvasBody>
            <OffcanvasBody>
              <ContactEdit
                contactDetail={this.state.contactData}
                closed={this.toggleRightCanvas}
                match={this.props.match}
              />
            </OffcanvasBody>

          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isAll}
          direction="end"
          toggle={this.isAllCanavas}
          style={{ width: 800 }}
          s
        >
          <OffcanvasHeader className="submittedWorksheet" toggle={this.isAllCanavas}>
            Activities
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab3 === "2",
                  })}
                  onClick={() => {
                    this.toggle3("2");
                    onGetAllActLead(lead.leadId)
                  }}
                >
                  All Activities
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab3 === "1",
                  })}
                  onClick={() => {
                    this.toggle3("1");
                    onGetFollowLead(lead.leadId);
                  }}
                >
                  Follow Up
                </NavLink>
              </NavItem>
              {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: this.state.activeTab3 === "3",
                    })}
                    onClick={() => {
                      this.toggle3("3");
                      this.fetchLeadMessage(lead.leadId)
                    }}
                  >
                    Message
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab3 === "4",
                  })}
                  onClick={() => {
                    this.toggle3("4");
                    onGetNoteLead(lead.leadId);

                  }}
                >
                  Add Notes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab3 === "5",
                  })}
                  onClick={() => {
                    this.toggle3("5");
                    onGetLeadCallLog(lead.leadId);

                  }}
                >
                  Call Log
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeTab3 === "6",
                  })}
                  onClick={() => {
                    this.toggle3("6");
                    onGetLeadEmailLog(lead.leadId);
                  }}
                >
                  Email Log
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent
              activeTab={this.state.activeTab3}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      agentId: parseInt(localStorage.getItem("userId")),
                      title: "Call log",
                      contactname: lead.contactName,
                      contactphone: lead.mobile,
                      contactemail: lead.email,
                      //addedDate: new Date(),
                      activityStartDate: new Date(),
                      startTime: "",
                      endTime: "",
                      activityStatus: 1,
                      activityType: 3,
                      activityRefId: lead.leadId,
                      activityDescription: (this.state && this.state.activityDescription) || "",
                      activityLocationType: 3,
                      activityLocation: "",

                      isActive: true,
                      category: 3
                    }}
                    validationSchema={Yup.object().shape({
                      activityDescription: Yup.string().required("This is Required"),
                      startTime: Yup.string().when('activityType', {
                        is: (val) => parseInt(val) === 1,
                        then: Yup.string().required("Start Time is Required"),
                        otherwise: Yup.string().nullable()
                      }),

                      endTime: Yup.string().when('activityType', {
                        is: (val) => parseInt(val) === 1,
                        then: Yup.string().required("End Time is Required"),
                        otherwise: Yup.string().nullable()
                      })

                    })}
                    onSubmit={(values) => {
                      const formattedValues = {
                        ...values,
                        activityStartDate: moment(values.activityStartDate).format('YYYY-MM-DD'),

                      };
                      onAddLeadFollowUp(formattedValues)
                      //this.toggleAllCanavas();


                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="builderName">
                                {this.props.t("Select Type")}
                              </Label>
                              <div className="clearfix"></div>
                              <div className="btn-group" role="group">
                                <SafeField type="radio" className="btn-check"
                                  name="activityType" id="btnradio4"
                                  value={3}
                                  checked={values.activityType === 3}
                                  onChange={() => {
                                    setFieldValue("activityType", 3)
                                    setFieldValue("title", "Call Log")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio4">Call</label>

                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio5" value={10}
                                  checked={values.activityType === 10}

                                  onChange={() => {
                                    setFieldValue("activityType", 10)
                                    setFieldValue("title", "Message")
                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio5">Message</label>

                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio6"
                                  value={4}
                                  checked={values.activityType === 4}

                                  onChange={() => {
                                    setFieldValue("activityType", 4)
                                    setFieldValue("title", "Email")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio6">Email</label>

                                <SafeField type="radio" className="btn-check" name="activityType" id="btnradio7" value={1}
                                  checked={values.activityType === 1}

                                  onChange={() => {
                                    setFieldValue("activityType", 1)
                                    setFieldValue("title", "Meeting")
                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="btnradio7">Meeting</label>
                              </div>
                              <ErrorMessage
                                name="activityType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="activityDescription">Description *</Label>
                              <SafeField
                                name="activityDescription"
                                onChange={handleChange}
                                as="textarea"
                                className={
                                  "form-control" +
                                  (errors.activityDescription && touched.activityDescription
                                    ? " is-invalid"
                                    : "")
                                }
                                id="activityDescription"
                              />
                              <ErrorMessage
                                name="activityDescription"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col md="12">
                            <FormGroup className="mb15">

                              <Label htmlFor="activityStartDate">
                                Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.activityStartDate && touched.activityStartDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.activityStartDate}
                                onChange={(value) => setFieldValue('activityStartDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate: "today"
                                }}
                              />
                              <ErrorMessage
                                name="logDate"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>
                          {values.activityType === 1 && (
                            <>
                              <Col md="6">
                                <TimePicker
                                  name="startTime"
                                  label="Start Time *"
                                  value={values.startTime}
                                  onChange={(val) => setFieldValue("startTime", val)}
                                  onBlur={() => setFieldTouched("startTime", true)}
                                  minTime={null}
                                  error={errors.startTime}
                                  touched={touched.startTime}
                                />

                                {errors.startTime && touched.startTime && (
                                  <div className="invalid-feedback">{errors.startTime}</div>
                                )}
                              </Col>

                              <Col md="6">
                                <TimePicker
                                  name="endTime"
                                  label="End Time *"
                                  value={values.endTime}
                                  onChange={(val) => setFieldValue("endTime", val)}
                                  onBlur={() => setFieldTouched("endTime", true)}
                                  minTime={values.startTime}
                                  disabled={!values.startTime}
                                  error={errors.endTime}
                                  touched={touched.endTime}
                                />
                              </Col>
                              <Col md="12">
                                <FormGroup className="mb-3">

                                  <div className="btn-group" role="group">
                                    <SafeField
                                      type="radio"
                                      className="btn-check"
                                      name="activityLocationType"
                                      id="btnradio9"
                                      value={3}
                                      checked={values.activityLocationType === 3}
                                      onChange={() => setFieldValue("activityLocationType", 3)}
                                      autoComplete="off"
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio9">
                                      In-person
                                    </label>

                                    <SafeField
                                      type="radio"
                                      className="btn-check"
                                      name="activityLocationType"
                                      id="btnradio10"
                                      value={1}
                                      checked={values.activityLocationType === 1}
                                      onChange={() => setFieldValue("activityLocationType", 1)}
                                      autoComplete="off"
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="btnradio10">
                                      Online
                                    </label>
                                  </div>
                                </FormGroup>
                              </Col>


                              <Col md="12">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="addressLine1">
                                    {this.props.t("Location")}
                                  </Label>
                                  {values.activityLocationType === 3 ? (
                                    <PlacesAutocomplete
                                      value={values.activityLocation}
                                      onChange={(value) => setFieldValue('activityLocation', value)}
                                      onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                    >
                                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                        <div>
                                          <input
                                            {...getInputProps({
                                              placeholder: 'Enter Address...',
                                              className: 'form-control',

                                            })}
                                          />
                                          <div className="">
                                            {loading ? <div>Loading...</div> : null}

                                            {suggestions.map((suggestion, i) => {
                                              const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                              const style = suggestion.active
                                                ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };

                                              return (
                                                <div
                                                  key={i}
                                                  {...getSuggestionItemProps(suggestion, {
                                                    style,
                                                  })}
                                                >
                                                  {suggestion.description}
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      )}
                                    </PlacesAutocomplete>
                                  ) : (
                                    <SafeField
                                      name="activityLocation"
                                      onChange={handleChange}
                                      type="text"
                                      className={
                                        "form-control" +
                                        (errors.activityLocation && touched.activityLocation
                                          ? " is-invalid"
                                          : "")
                                      }
                                      id="activityLocation"

                                    />
                                  )}
                                </FormGroup>
                              </Col>
                            </>
                          )}
                        </Row>

                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                  {leadFollows && leadFollows.length > 0 ? (
                    <>
                      <div className="mb-5 h4 card-title mt-20">Follow-up History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(leadFollows, (follLog, follLogkey) => (

                          <li className="event-list eventlist" key={"_note_" + follLogkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{follLog.activityStartDate}</Moment>


                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">
                                  {follLog.displayTitle}
                                </h5>
                              </div>
                            </div>
                            <div className="exNote">{follLog.activityDetails}</div>
                          </li>
                        ))}

                      </ul>
                    </>
                  ) : null}

                </div>
              </TabPane>
              <TabPane tabId="2">
                <div className="tabContent">
                  {allactivities && allactivities.length > 0 ? (
                    <ul className="verti-timeline list-unstyled">
                      {map(allactivities, (allactivity, allactkey) => {
                        // Choose icon based on activitySubType
                        let icon;
                        if ([8, 9, 7].includes(allactivity.activitySubType)) {
                          icon = emaillog;
                        } else if ([3, 4, 5].includes(allactivity.activitySubType)) {
                          icon = phonelog;
                        } else if (allactivity.activitySubType === 10) {
                          icon = follow;
                        } else {
                          icon = notes;
                        }

                        return (
                          <li className="event-list eventlist" key={`_allact_${allactkey}`}>
                            <div className="event-timeline-dot">
                              <img src={icon} alt="activity-icon" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{allactivity.addedDate}</Moment>
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">
                                  {
                                    localization[
                                    `ActivitySubType_${allactivity.activityType}_${allactivity.activitySubType}`
                                    ]
                                  }
                                </h5>
                              </div>
                            </div>
                            <div className="exNote">{allactivity.activityRemarks}</div>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <div className="text-muted text-center py-3">No activity recorded as yet.</div>
                  )}

                </div>
              </TabPane>
              {userdetail?.agentTimeZone?.isTwilioIntegrationEnabled && (
                <TabPane tabId="3">
                  <div className="tabContent">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        messageFromId: localStorage.getItem("userId"),
                        messageToId: lead.leadId,
                        messageFrom: 'Realtor',
                        messageTo: 'contact',
                        messageText: '',
                        agentId: localStorage.getItem("userId"),
                        isActive: true,


                      }}
                      validationSchema={Yup.object().shape({
                        messageText: Yup.string().max(500, 'This filed contains only 500 characters only').required("This is Required")
                      })}

                      onSubmit={this.handleSubmit}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >

                          <Row>
                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="addNote" className="w-100">
                                  Add Message *
                                </Label>
                                <SafeField
                                  name="messageText"
                                  onChange={handleChange}
                                  // placeholder="only 500 Characters are allowed"
                                  as="textarea"
                                  className={
                                    "form-control" +
                                    (errors.messageText && touched.messageText
                                      ? " is-invalid"
                                      : "")
                                  }
                                  id="messageText"
                                />
                                <ErrorMessage
                                  name="messageText"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Send")}</button></div>


                        </Form>
                      )}
                    </Formik>

                    {leadMessages && leadMessages.length > 0 ? (
                      <>
                        <div className="mb-5 h4 card-title mt-20">Message History</div>
                        <ul className="verti-timeline list-unstyled">

                          {map(leadMessages, (noteLog, notekey) => (

                            <li className="event-list eventlist" key={"_note_" + notekey}>
                              <div className="event-timeline-dot">
                                <i className="bx bx-right-arrow-circle font-size-18" />
                              </div>
                              <div className="d-flex">
                                <div className="flex-shrink-0 me-3">
                                  <h5 className="font-size-14">
                                    <Moment format="D MMM YY">{noteLog.createdDate}</Moment>


                                  </h5>
                                </div>
                                <div className="flex-grow-1">
                                  <h5 className="font-size-14"></h5>
                                </div>
                              </div>
                              <div className="exNote">{noteLog.messageText}</div>
                            </li>
                          ))}

                        </ul>
                      </>
                    ) : null}
                  </div>
                </TabPane>
              )}
              <TabPane tabId="4">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{

                      refId: lead.leadId,
                      addedBy: parseInt(localStorage.getItem('userId')),
                      createdFor: lead.leadId,
                      remarks:  "",
                      addedDate: new Date()




                    }}
                    validationSchema={Yup.object().shape({
                      remarks: Yup.string().required("This is Required")
                    })}

                    onSubmit={values => {
                      onAddLeadNote(values)
                      //this.toggleAllCanavas();
                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="remarks">
                                {this.props.t("Add Note *")}
                              </Label>
                              <SafeField
                                name="remarks"
                                onChange={handleChange}

                                as="textarea"
                                className={
                                  "form-control" +
                                  (errors.remarks && touched.remarks
                                    ? " is-invalid"
                                    : "")
                                }
                                id="remarks"
                              />
                              <ErrorMessage
                                name="remarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">{this.props.t("Save")}</button></div>


                      </Form>
                    )}
                  </Formik>
                  {leadNotes && leadNotes.length > 0 ? (
                    <>
                      <div className="mb-5 h4 card-title mt-20">Notes History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(leadNotes, (noteLog, notekey) => (

                          <li className="event-list eventlist" key={"_note_" + notekey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{noteLog.addedDate}</Moment>


                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14"></h5>
                              </div>
                            </div>
                            <div className="exNote">{noteLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </>
                  ) : null}
                </div>
              </TabPane>
              <TabPane tabId="5">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      actionType: 'Call',
                      addedDate: new Date(),
                      refId: lead.leadId,
                      callNote: ''


                    }}
                    validationSchema={Yup.object().shape({
                      actionType: Yup.string().required(
                        "Please Select Action"
                      ),
                      // callNote: Yup.string().required(
                      //   "Enter Note"
                      // ),
                    })}

                    onSubmit={values => {
                      onAddCallLog(values)
                      //this.toggleAllCanavas();
                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row className="mt20 mb20">

                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="builderName">
                                {this.props.t("Select Type")}
                              </Label>
                              <div className="clearfix"></div>
                              <div className="btn-group" role="group">
                                <SafeField type="radio" className="btn-check"
                                  name="actionType" id="actionType1"
                                  value='Call'
                                  checked={values.actionType === 'Call'}
                                  onChange={() => {
                                    setFieldValue("actionType", 'Call')

                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType1">Call</label>

                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType2" value='No Answer'
                                  checked={values.actionType === 'No Answer'}

                                  onChange={() => {
                                    setFieldValue("actionType", 'No Answer')

                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType2">No Answer</label>

                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType3"
                                  value={4}
                                  checked={values.actionType === 'Left Voicemail'}

                                  onChange={() => {

                                    setFieldValue("actionType", "Left Voicemail")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType3">Left Voicemail</label>

                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType4" value='Bad Number'
                                  checked={values.actionType === 'Bad Number'}

                                  onChange={() => {
                                    setFieldValue("actionType", 'Bad Number')

                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType4">Bad Number</label>
                              </div>
                              <ErrorMessage
                                name="activityType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>


                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="addedDate">
                                Log Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.addedDate && touched.addedDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.addedDate}
                                onChange={(value) => setFieldValue('addedDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                              <ErrorMessage
                                name="addedDate"
                                component="div"
                                className="invalid-feedback"
                              />

                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="callNote">
                                Add Message
                              </Label>
                              <SafeField
                                name="callNote"
                                onChange={handleChange}
                                as="textarea"

                                className="form-control"

                                id="callNote"

                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                  {calllogs && calllogs.length > 0 ? (
                    <>
                      <div className="mb-5 h4 card-title mt-20">Call Log History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(calllogs, (callLog, callkey) => (

                          <li className="event-list eventlist" key={"_call_" + callkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{callLog.addedDate}</Moment>

                                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">{localization["ActivitySubType_" + callLog.activityType + "_" + callLog.activitySubType]}</h5>
                              </div>
                            </div>
                            <div className="exNote">{callLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </>
                  ) : null}
                </div>
              </TabPane>
              <TabPane tabId="6">
                <div className="tabContent">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      actionType: 'Email Sent',
                      addedDate: new Date(),
                      refId: lead.leadId

                    }}
                    validationSchema={Yup.object().shape({
                      actionType: Yup.string().required(
                        "Please Select Action"
                      )
                    })}

                    onSubmit={values => {
                      onAddEmailLog(values)

                    }}
                  >
                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                      <Form
                        className="needs-validation"
                      >

                        <Row className="mt20 mb20">
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="builderName">
                                {this.props.t("Select Type")}
                              </Label>
                              <div className="clearfix"></div>
                              <div className="btn-group" role="group">
                                <SafeField type="radio" className="btn-check"
                                  name="actionType" id="actionType_e_1"
                                  value='Email Sent'
                                  checked={values.actionType === 'Email Sent'}
                                  onChange={() => {
                                    setFieldValue("actionType", 'Email Sent')

                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType_e_1">Email Sent</label>

                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType_e_2" value='Email Received'
                                  checked={values.actionType === 'Email Received'}

                                  onChange={() => {
                                    setFieldValue("actionType", 'Email Received')

                                  }}

                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType_e_2">Email Received</label>

                                <SafeField type="radio" className="btn-check" name="actionType" id="actionType_e_3"
                                  value={4}
                                  checked={values.actionType === 'Email Bounced'}

                                  onChange={() => {

                                    setFieldValue("actionType", "Email Bounced")
                                  }}
                                  autoComplete="off" />
                                <label className="btn btn-outline-secondary" htmlFor="actionType_e_3">Email Bounced</label>


                              </div>
                              <ErrorMessage
                                name="activityType"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>




                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="addedDate">
                                Log Date
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.addedDate && touched.addedDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.addedDate}
                                onChange={(value) => setFieldValue('addedDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                              <ErrorMessage
                                name="addedDate"
                                component="div"
                                className="invalid-feedback"
                              />

                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="remarks">
                                Add Message
                              </Label>
                              <SafeField
                                name="remarks"
                                onChange={handleChange}
                                as="textarea"

                                className="form-control"

                                id="remarks"

                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>


                      </Form>
                    )}
                  </Formik>
                  {emaillogs && emaillogs.length > 0 ? (
                    <>
                      <div className="mb-5 h4 card-title mt-20">Email Log History</div>
                      <ul className="verti-timeline list-unstyled">

                        {map(emaillogs, (emailLog, emailkey) => (

                          <li className="event-list eventlist" key={"_email_" + emailkey}>
                            <div className="event-timeline-dot">
                              <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                              <div className="flex-shrink-0 me-3">
                                <h5 className="font-size-14">
                                  <Moment format="D MMM YY">{emailLog.addedDate}</Moment>

                                  <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                </h5>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14">{localization["ActivitySubType_" + emailLog.activityType + "_" + emailLog.activitySubType]}</h5>
                              </div>
                            </div>
                            <div className="exNote">{emailLog.activityRemarks}</div>
                          </li>
                        ))}

                      </ul>
                    </>
                  ) : null}
                </div>
              </TabPane>
            </TabContent>



          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}
AllContacts.propTypes = {
  t: PropTypes.any,
  onGetAllContact: PropTypes.func,
  contacts: PropTypes.array,
  gridLoading: PropTypes.object,
  match: PropTypes.object,
  onAddLeadNote: PropTypes.func,
  onGetNoteLead: PropTypes.func,
  leadNotes: PropTypes.array,
  onGetFollowLead: PropTypes.func,
  leadFollows: PropTypes.array,
  onAddLeadFollowUp: PropTypes.func,
  onGetLeadEmailLog: PropTypes.func,
  onGetLeadCallLog: PropTypes.func,
  calllogs: PropTypes.array,
  emaillogs: PropTypes.array,
  onAddCallLog: PropTypes.func,
  onAddEmailLog: PropTypes.func,
  onSendWorksheetEmailLog: PropTypes.func,
  onGetAllActLead: PropTypes.func,
  allactivities: PropTypes.array,
  userdetail: PropTypes.object,
  isResponsive:PropTypes.object
}

const mapStateToProps = ({ contact, projectleads }) => (
  {
    gridLoading: contact.gridLoading,
    contacts: contact.contacts,
    leadNotes: contact.noteLogs,
    allactivities: contact.allactivities,
    leadFollows: projectleads.leadFollows,
    calllogs: contact.callLogs,
    emaillogs: contact.emailLogs
  })
const mapDispatchToProps = dispatch => ({
  onGetAllContact: (agentId) => dispatch(getContacts(agentId)),

  onAddLeadNote: (data) => dispatch(addTabNote(data)),
  onGetNoteLead: (leadId) => dispatch(getTabNote(leadId)),
  onGetFollowLead: (leadId) => dispatch(getContactActivityFollowUp(leadId)),
  onAddLeadFollowUp: (data) => dispatch(addContactActivityFollowUp(data)),
  onAddCallLog: (data) => dispatch(addTabCall(data)),
  onGetLeadCallLog: (leadId) => dispatch(getTabCall(leadId)),
  onAddEmailLog: (data) => dispatch(addTabEmail(data)),
  onGetLeadEmailLog: (leadId) => dispatch(getTabEmail(leadId)),
  onGetAllActLead: (leadId) => dispatch(getAllContactActivityTab(leadId)),
  onDeleteLead: (id) => dispatch(deleteLead(id))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AllContacts))


